import React from 'react';
import WhatWeOfferImg from '../../asset/WhatWeOffer.webp'

export default function WhatWeOffer() {

    return (
        <div className='flex flex-col lg:flex-row items-center justify-around max-w-[78rem] py-12 mx-auto px-4 sm:px-6 gap-8 lg:gap-0'>
            <div className="w-[50%] shrink-0 left-[section] max-md:w-full max-md:max-w-none">
                <h2 className="text-[#966376] font-sans text-lg font-semibold leading-[27px] uppercase mb-3 max-sm:text-base">
                    What We Offer
                </h2>
                <h3 className="text-[#0B2549] font-regrade text-5xl font-semibold leading-[57.6px] mb-6 max-md:w-full max-md:text-[40px] max-sm:text-[32px]">
  Everything You Need to
  <span className="hidden md:inline"><br /></span>
  <span className="inline md:hidden"> </span>
  Work Smarter
</h3>

                <p className="text-[#6D7E94] font-sans text-base font-[500] leading-[32.4px] w-[90%] mb-3.5 max-md:w-full max-sm:text-base">
                Offis Bay Realty provides a verified business address in Chennai’s central business district (Anna Salai), complete with GST-ready documentation, call answering services, and meeting room access. Ideal for startups, e-commerce sellers, remote teams, and consultants.
                </p>
                <div className="mt-3.5 relative">

                </div>
            </div>

            <img className="w-auto sm:w-[50%]" alt='' src={WhatWeOfferImg} />

        </div>
    )
}
